import { ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

import { FlexTimeActivity, FlexTimeActivityInstance } from 'libs/domain';
import { BehaviorSubject } from 'rxjs';
import { $enum } from 'ts-enum-util';

import { FlexTimePermissionsService } from '@shared/services/flex-time/flex-time-permissions';

import { ActivityCardFields, FtmSharedMessages } from '../../ftm-shared.constants';

type Item = {
  activity: FlexTimeActivity;
  instance?: FlexTimeActivityInstance;
};

type PanelState = 'opened' | 'closed';

export const normalizeActivity = (activity: FlexTimeActivityInstance | FlexTimeActivity): Item => {
  // if flex time period exists it's instances
  if ((activity as FlexTimeActivityInstance)?.flexTimePeriod) {
    const { flexTimeActivity, ...instance } = activity as FlexTimeActivityInstance;
    return {
      activity: flexTimeActivity,
      instance,
    };
  } else {
    return {
      activity: activity as FlexTimeActivity,
      instance: null,
    };
  }
};

@Component({
  selector: 'mg-ftm-activity-card',
  templateUrl: './ftm-activity-card.component.html',
  styleUrls: ['./ftm-activity-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FtmActivityCardComponent {
  // Children

  @ViewChild(MatExpansionPanel) accordion: MatExpansionPanel;
  @ContentChild('actions', { read: TemplateRef })
  actions: TemplateRef<any>;

  // Inputs

  @Input() set activity(activity: FlexTimeActivityInstance | FlexTimeActivity) {
    if (activity) {
      this.item = normalizeActivity(activity);
    }
  }
  @Input() visibleFields: ActivityCardFields[] = [...$enum(ActivityCardFields).getValues()];
  @Input() selected: boolean;

  // Constants

  public FIELDS = ActivityCardFields;
  public MESSAGES = FtmSharedMessages;

  // Observables

  public readonly _mobilePanelStateSubject = new BehaviorSubject<PanelState>('closed');
  public readonly mobilePanelState$ = this._mobilePanelStateSubject.asObservable();

  // Miscellaneous

  public item: Item;
  public isStaff = this._flexPermissions.isFlexTimeSelfManager();

  // Component Constructor

  constructor(private _flexPermissions: FlexTimePermissionsService) {}

  // Public Methods

  public togglePanelState(action: PanelState) {
    this._mobilePanelStateSubject.next(action);
  }
}
